import { DOUBLE_DASH } from 'consts/placeholders';
import Timeline, { TimelineItem } from 'lib/Timeline';
import { Asset } from 'components/pages/InventoryManagement/AssetList/AssetSidebar/AssetSidebar.types';

const Restrictions = ({ asset }: Asset): React.ReactElement => {
  const prohibitionCounters =
    asset?.prohibitionCounters?.map(({ productCategoryName }) => productCategoryName ?? DOUBLE_DASH).join(', ') ||
    DOUBLE_DASH;

  const blacklists =
    asset?.blacklists?.map(({ organisationUuid }) => organisationUuid ?? DOUBLE_DASH).join(', ') || DOUBLE_DASH;

  return (
    <div>
      <h2 className="sub-header-base mb-8">Restrictions</h2>
      <div className="pl-2">
        <Timeline>
          <TimelineItem
            title={
              <div className="grid grid-cols-3 gap-x-4 items-center">
                <p className="body-sm">Counters prohibition</p>
                <p className="body-base break-all" data-test-id="asset-prohibition-counters">
                  {prohibitionCounters}
                </p>
              </div>
            }
          />
          <TimelineItem
            title={
              <div className="grid grid-cols-3 gap-x-4 items-center">
                <p className="body-sm">Blacklist</p>
                <p className="body-base" data-test-id="asset-blacklists">
                  {blacklists}
                </p>
              </div>
            }
          />
        </Timeline>
      </div>
    </div>
  );
};

export default Restrictions;
